import { createContext } from "react"

export const countryLanguageContext = createContext<string>("")
